// extracted by mini-css-extract-plugin
export default {"button":"menu-item-secondary__button___xw1k- menu-item__button___QrH5n base__button___zT0JW"};